import { render, staticRenderFns } from "./OnboardingDialog.vue?vue&type=template&id=31156cf8&scoped=true&"
import script from "./OnboardingDialog.vue?vue&type=script&lang=js&"
export * from "./OnboardingDialog.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingDialog.vue?vue&type=style&index=0&id=31156cf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31156cf8",
  null
  
)

export default component.exports